import { pad, stringToHex, zeroHash, hexToString } from 'viem';
import { getStoredReferralCode } from '../components/RefLinkCapture.js';

/** Max length for custom referral code text in registration (alphanumeric only). */
export const REFERRAL_REGISTER_TEXT_MAX = 20;

export function getRefTextFromCookie() {
  return getStoredReferralCode();
}

/** Matches Solidity `bytes32(bytes(string))`: UTF-8, right-padded to 32 bytes. */
export function referralTextToBytes32(str) {
  const s = String(str ?? '').trim();
  if (!s) return zeroHash;
  const hex = stringToHex(s);
  try {
    return pad(hex, { size: 32, dir: 'right' });
  } catch {
    throw new Error('Referral code is too long (max 32 bytes UTF-8)');
  }
}

/** Decode vault `bytes32` referral code for display (UTF-8, strip trailing NULs). */
export function decodeReferralBytes32FromContract(raw) {
  if (raw == null || typeof raw !== 'string' || !raw.startsWith('0x')) return '';
  if (raw.toLowerCase() === zeroHash.toLowerCase()) return '';
  try {
    return hexToString(raw).replace(/\0+$/, '').trim();
  } catch {
    return '';
  }
}
